<template>
  <RevDrawer
    v-bind="$attrs"
    :close-button-label="i18n(translations.manageWeekendDeliveryDrawerClose)"
    :name="drawerId"
    size="medium"
    :title="i18n(translations.manageWeekendDeliveryDrawerTitle)"
  >
    <template v-if="$slots.body" #body="{ close }">
      <slot :close="() => close()" name="body" />
    </template>
    <template v-if="$slots.footer" #footer="{ close }">
      <slot :close="() => close()" name="footer" />
    </template>
    <template v-if="$slots.trigger" #trigger="{ open }">
      <slot name="trigger" :open="() => open()" />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useId } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import translations from './ManageWeekendDeliveryDrawer.translations'

defineOptions({
  inheritAttrs: false,
})

const i18n = useI18n()
const drawerId = useId()
</script>
